/*
 * Viridimania Wishlist
 * Sistema client-side basato su localStorage. Persiste lista handle prodotti per dispositivo/browser.
 * API pubblica: window.ViridimaniaWishlist
 *   - list()          → ['handle-1', 'handle-2', ...]
 *   - has(handle)     → boolean
 *   - add(handle)     → boolean (true se aggiunto, false se già presente)
 *   - remove(handle)  → boolean (true se rimosso)
 *   - clear()         → void
 *   - count()         → number
 *   - on(event, cb)   → subscribe a 'change', 'add', 'remove', 'clear' events
 *
 * Sincronizzato tra tab via storage event.
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'viridimania_wishlist_v1';
  var listeners = { change: [], add: [], remove: [], clear: [] };

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      // localStorage non disponibile (modalità privacy)
      console.warn('[wishlist] localStorage non disponibile', e);
    }
  }

  function fire(event, payload) {
    (listeners[event] || []).forEach(function(cb) {
      try { cb(payload); } catch (e) { console.error(e); }
    });
    if (event !== 'change') fire('change', { type: event, payload: payload, list: read() });
  }

  var Wishlist = {
    list: function() {
      return read();
    },
    has: function(handle) {
      if (!handle) return false;
      return read().indexOf(handle) !== -1;
    },
    add: function(handle) {
      if (!handle) return false;
      var arr = read();
      if (arr.indexOf(handle) !== -1) return false;
      arr.push(handle);
      write(arr);
      fire('add', handle);
      return true;
    },
    remove: function(handle) {
      if (!handle) return false;
      var arr = read();
      var idx = arr.indexOf(handle);
      if (idx === -1) return false;
      arr.splice(idx, 1);
      write(arr);
      fire('remove', handle);
      return true;
    },
    toggle: function(handle) {
      return this.has(handle) ? (this.remove(handle), false) : (this.add(handle), true);
    },
    clear: function() {
      write([]);
      fire('clear', null);
    },
    count: function() {
      return read().length;
    },
    on: function(event, cb) {
      if (!listeners[event]) listeners[event] = [];
      listeners[event].push(cb);
      return function unsubscribe() {
        var i = listeners[event].indexOf(cb);
        if (i !== -1) listeners[event].splice(i, 1);
      };
    }
  };

  // Sync tra tabs: ascolta cambiamenti dal localStorage di altre finestre
  window.addEventListener('storage', function(e) {
    if (e.key === STORAGE_KEY) {
      fire('change', { type: 'sync', list: read() });
    }
  });

  // Init: aggiorna tutti i [data-wishlist-toggle] presenti nel DOM con stato corretto
  function syncToggles() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      if (!handle) return;
      var active = Wishlist.has(handle);
      btn.toggleAttribute('data-wishlist-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  // Aggiorna l'icona wishlist nell'header (count badge + colore rosso quando >0)
  function syncHeader() {
    var count = Wishlist.count();
    document.querySelectorAll('[data-wishlist-header-link]').forEach(function(link) {
      link.toggleAttribute('data-has-items', count > 0);
    });
    document.querySelectorAll('[data-wishlist-header-count]').forEach(function(badge) {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count === 0;
    });
  }

  // Gestione click sui toggle (delegation)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    Wishlist.toggle(handle);
  });

  // Aggiorna stato visivo quando wishlist cambia
  Wishlist.on('change', function() {
    syncToggles();
    syncHeader();
  });

  // Init al load
  function initAll() {
    syncToggles();
    syncHeader();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.ViridimaniaWishlist = Wishlist;
})();
